export default __webpack_public_path__ + "static/media/Link3.f89fcbab.svg";